import { FormControl, FormGroup } from '@angular/forms';
import { BookingSummaryDto } from '@opb-workspace/shared';
import { searchTextFromBookingInputValue } from './step2-booking-summary.util';

/** Campos del usuario de sesión necesarios para mostrar “cliente” en booking externo. */
export interface PortalUserIdentity {
    clientName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
}

export function resolvePortalClientDisplayName(
    user: PortalUserIdentity | null | undefined,
    customerNameFromForm?: string | null,
): string {
    const cn = user?.clientName?.trim();
    if (cn) return cn;
    const cf = customerNameFromForm?.trim();
    if (cf) return cf;
    const full = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim();
    if (full) return full;
    const em = user?.email?.trim();
    if (em) {
        const local = em.split('@')[0]?.trim();
        if (local) return local;
    }
    return '';
}

export interface BookingSecondColumnBlurInput {
    form: FormGroup;
    bookingInputCtrl: FormControl<string | BookingSummaryDto>;
    availableBookings: BookingSummaryDto[];
    exporterCtrl: FormControl<string>;
    portalClientName: string;
}

export type BookingSecondColumnLabel = 'Cliente';

/**
 * Segunda columna: siempre muestra el cliente del usuario (portal), no el exportador del booking.
 */
export function applySecondColumnAfterBookingBlur(
    input: BookingSecondColumnBlurInput,
): BookingSecondColumnLabel {
    const bookingId = input.form.get('selectedBookingId')?.value as
        | number
        | null;
    if (bookingId != null) {
        input.exporterCtrl.setValue(input.portalClientName, {
            emitEvent: false,
        });
        return 'Cliente';
    }
    const text = searchTextFromBookingInputValue(
        input.bookingInputCtrl.value,
        input.availableBookings,
    ).trim();
    if (text) {
        input.form.patchValue({ bookingNumber: text }, { emitEvent: false });
        input.bookingInputCtrl.setValue(text, { emitEvent: false });
        input.exporterCtrl.setValue(input.portalClientName, {
            emitEvent: false,
        });
        return 'Cliente';
    }
    input.form.patchValue({ bookingNumber: '' }, { emitEvent: false });
    input.exporterCtrl.setValue(input.portalClientName, {
        emitEvent: false,
    });
    return 'Cliente';
}
